export default {"src":"/_next/static/media/toggl-hire-icon.7f12c80a.svg","height":1502,"width":1502};